<template>
  <v-container grid-list-lg fluid>
    <v-layout wrap>
<!--
      <v-btn class='ml-1 oem-text-color' @click='testGetState(0)'>
        Test Get State #0
      </v-btn>
      <v-btn class='ml-1 oem-text-color' @click='testSetState(0, 0)'>
        Test Set State #0 Startup
      </v-btn>
      <v-btn class='ml-1 oem-text-color' @click='testSetState(0, 1)'>
        Test Set State #0 Unchecked
      </v-btn>
      <v-btn class='ml-1 oem-text-color' @click='testSetState(0, 2)'>
        Test Set State #0 Normal
      </v-btn>
      <v-btn class='ml-1 oem-text-color' @click='testSetState(0, 3)'>
        Test Set State #0 Warning (Under)
      </v-btn>
      <v-btn class='ml-1 oem-text-color' @click='testSetState(0, 4)'>
        Test Set State #0 Warning (Over)
      </v-btn>
      <v-btn class='ml-1 oem-text-color' @click='testSetState(0, 5)'>
        Test Set State #0 Alarm (Under)
      </v-btn>
      <v-btn class='ml-1 oem-text-color' @click='testSetState(0, 6)'>
        Test Set State #0 Alarm (Over)
      </v-btn>
      <v-btn class='ml-1 oem-text-color' @click='testGetState(1)'>
        Test Get State #1
      </v-btn>
      <v-btn class='ml-1 oem-text-color' @click='testSetState(1, 0)'>
        Test Set State #1 Startup
      </v-btn>
      <v-btn class='ml-1 oem-text-color' @click='testSetState(1, 1)'>
        Test Set State #1 Unchecked
      </v-btn>
      <v-btn class='ml-1 oem-text-color' @click='testSetState(1, 2)'>
        Test Set State #1 Normal
      </v-btn>
      <v-btn class='ml-1 oem-text-color' @click='testSetState(1, 3)'>
        Test Set State #1 Warning (Under)
      </v-btn>
      <v-btn class='ml-1 oem-text-color' @click='testSetState(1, 4)'>
        Test Set State #1 Warning (Over)
      </v-btn>
      <v-btn class='ml-1 oem-text-color' @click='testSetState(1, 5)'>
        Test Set State #1 Alarm (Under)
      </v-btn>
      <v-btn class='ml-1 oem-text-color' @click='testSetState(1, 6)'>
        Test Set State #1 Alarm (Over)
      </v-btn>
-->
      <v-flex xs12 class='pa-3'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            Active Alarm States
          </v-card-title>
          <v-card-text>
            <div>
              <v-data-table
                :headers='headersStates'
                :items='storeState.alarmStates'
                must-sort
                hide-actions=''
              >
                <template v-slot:items='props'>
                  <td>{{ props.item.id + 1 }}</td>
                  <td>{{ storeState.alarmTypes[props.item.type].text }}</td>
                  <td>{{ getVinLineLoadOrCtText(props.item) }}</td>
                  <td>{{ storeState.alarmTypes[props.item.type].setPointApplicable ?
                         props.item.setPoint + ' ' +
                         storeState.alarmTypes[props.item.type].unit :
                         '#NA'}}
                  </td>
                  <td>{{ storeState.alarmTypes[props.item.type].deadbandUnit !== '' ?
                           (props.item.deadband + ' ' +
                            storeState.alarmTypes[props.item.type].deadbandUnit) :
                           '#NA'}}
                   </td>
                  <td>{{ storeState.alarmTypes[props.item.type].delayApplicable ?
                           props.item.delay :
                           '#NA'}}
                  </td>
                  <td>
                    <v-checkbox
                      :input-value='props.item.led'
                      primary
                      hide-details
                      :disabled="true"
                      class='oem-text-color disabledCheckbox'
                    ></v-checkbox>
                  </td>
                  <td>
                    <v-checkbox
                      :input-value='props.item.relay'
                      primary
                      hide-details
                      :disabled="true"
                      class='oem-text-color disabledCheckbox'
                    ></v-checkbox>
                  </td>
                  <td>{{ $store.getStateTextForAlarmLogs(props.item.state) }}</td>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md6 class='pa-3'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            Active LED State
          </v-card-title>
          <v-card-text>
            <v-layout row>
              <v-flex xs4 sm4 md4>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content class='oem-quaternary-text-color'>
                      LED State
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex xs3 sm3 md3>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>
                      <lightBulb :isOn="storeState.alarmLed"></lightBulb>
                      <img id="setraLabel" ref="setraLabel" src='../assets/img/SetraBlue_logo.jpg' style="display:none" />
                      <img id="flukeLabel" ref="flukeLabel" src='../assets/img/Fluke_logo.jpg' style="display:none" />
                      <img id="siemensLabel" ref="siemensLabel" src='../assets/img/Siemens_logo.jpg' style="display:none" />
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex xs5 sm5 md5>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>
                      <div>
                        {{ storeState.alarmLed ? 'On' : 'Off' }}
                      </div>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md6 class='pa-3'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            Active Relay State
          </v-card-title>
          <v-card-text>
            <v-layout row>
              <v-flex xs4 sm4 md4>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content class='oem-quaternary-text-color'>
                      Relay State
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex xs3 sm3 md3>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>
                      <lightBulb :isOn="storeState.alarmRelay"></lightBulb>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex xs5 sm5 md5>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>
                      {{ storeState.alarmRelay ? 'Triggered (closed)' : 'Untriggered (open)' }}
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class='pa-3'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            Alarm Log
            <v-spacer/>
            <v-btn class='oem-color ma-0' flat @click='exportAlarmLogs()'>
              <v-icon>import_export</v-icon>
              Export alarm logs
            </v-btn>
            <v-btn class='oem-color ma-0' flat @click='reload()'>
              <v-icon>refresh</v-icon>
              Reload alarm log values
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div>
              <v-data-table
                :headers='headersLog'
                :items='storeState.alarmLog'
                must-sort
                pagination-sync.rowPerPage=25
                :rows-per-page-items='paginationItems'
                v-bind:pagination.sync='pagination'
              >
                <template v-slot:items='props'>
                  <td>{{ props.item.timeEpoch | realtimeTimestampToDate}}</td>
                  <td>{{ props.item.timeEpoch | realtimeTimestampToTime}}</td>
                  <td>{{ $store.getAlarmTextForAlarmLogs(props.item.alarmConfig) }}</td>
                  <td>{{ $store.getStateTextForAlarmLogs(props.item.oldState) }}</td>
                  <td>{{ $store.getStateTextForAlarmLogs(props.item.alarmConfig.state) }}</td>
                  <td><v-checkbox
                      :input-value='props.item.led'
                      primary
                      hide-details
                      :disabled="true"
                      class='oem-text-color disabledCheckbox'
                    ></v-checkbox></td>
                  <td><v-checkbox
                      :input-value='props.item.relay'
                      primary
                      hide-details
                      :disabled="true"
                      class='oem-text-color disabledCheckbox'
                    ></v-checkbox></td>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-dialog v-model='updateDialog' persistent max-width='500px'>
        <v-card class="mx-auto">
          <v-card-title class='headline font-weight-regular oem-color'>
            File Download
          </v-card-title>
          <v-card-text>
            <span class='oem-text-color'>
              <div class="d-flex ma-3">
                {{ updateText }}
                <v-spacer></v-spacer>
                <hollow-dots-spinner
                  :animation-duration="1000"
                  :dot-size="15"
                  :dots-num="3"
                  color= "var(--primary-color)"
                  class="pl-5"
                ></hollow-dots-spinner>
              </div>
            </span>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model='generatedByDialog' ref='generatedByDialog' persistent max-width='500px'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            Add User Details
          </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-text-field
                ref="GeneratedBy"
                v-model="GeneratedBy"
                data-vv-name="Generated by"
                hint='Max 30 characters'
                :error-messages="errors.collect('Generated by')"
                :label='"Generated by:"'
                :rules="[
                  () => !!GeneratedBy || 'This field is required',
                  () => !!GeneratedBy && GeneratedBy.length <= 30 || 'GeneratedBy must be less than 30 characters'
                ]"
                counter
                maxlength='30'
                require
              ></v-text-field>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class='oem-button' flat @click='cancel()'>
              Cancel
            </v-btn>
            <v-btn class='oem-button' flat @click='confirm()'>OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { HollowDotsSpinner } from 'epic-spinners';
import ajax from '../ajax';
import lightBulb from './LightBulb.vue';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: 'AlarmLog',
  components: {
    HollowDotsSpinner,
    lightBulb,
  },
  computed: {
    headersLog() {
      const list = [
        { text: 'Date', value: 'timeEpoch' },
        { text: 'Time', value: 'timeEpoch', sortable: false },
        { text: 'Alarm Config', sortable: false },
        { text: 'Old State', value: 'oldState' },
        { text: 'New State', value: 'alarmConfig.state' },
        { text: 'Current LED State', value: 'led' },
        { text: 'Current Relay State', value: 'relay' },
      ];
      return list;
    },
    headersStates() {
      const list = [
        { text: '#', value: 'id' },
        { text: 'Alarm Type', value: 'type' },
        { text: 'Vin / Line / Load / CT', value: 'vinLineLoadOrCt' },
        { text: 'Alarm Set Point', value: 'setPoint' },
        { text: 'Deadband', value: 'deadband' },
        { text: 'Delay Seconds', value: 'delay' },
        { text: 'LED Indication', value: 'led' },
        { text: 'Relay Trigger', value: 'relay' },
        { text: 'Active State', value: 'state' },
      ];
      return list;
    },
  },

  data() {
    return {
      paginationItems: [10, 20, 50, { text: 'All', value: -1 }],
      pagination: { sortBy: 'timeEpoch', descending: true, rowsPerPage: 10 },
      storeState: this.$store.state,
      powerFactorOptions: [{ text: 'IEC', value: 0 }, { text: 'IEEE', value: 1 }],
      updateDialog: false,
      updateText: '',
      generatedByDialog: false,
      GeneratedBy: '',
    };
  },

  methods: {
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    reload() {
      this.$store.state.alarmLog = [];
      this.$store.updateAlarmLog();
    },
    getUserName() {
      this.GeneratedBy = '';
      this.generatedByDialog = true;
    },
    exportAlarmLogs() {
      if (this.GeneratedBy === '') {
        this.getUserName();
        return;
      }
      this.updateText = 'Downloading the file. Please wait.';
      this.updateDialog = true;
      const fileName = `SPM${this.$store.getDeviceModelNumberText()}EDN_${this.storeState.data.deviceInfo.serial}_Alarm_Log.pdf`;
      // document basics
      this.doc = {
        info: {
          title: fileName,
        },
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            color: '#1d428a',
          },
          subheader: {
            fontSize: 15,
            bold: true,
            color: '#1d428a',
            // alignment: 'center'
          },
          setraTable: {},
          tableHeader: {
            bold: true,
            fontsize: 13,
          },
        },
        content: [
          {
            image: 'data:image/jpeg;base64,' + this.OEMlabel(),
            width: this.getOEMLabelWidth(),
            height: this.getOEMLabelHeight(),
            alignment: 'right',
          },
          { text: 'Powermeter Alarm Logs Record', style: 'header' },
        ],
      };

      // Adding date and time here
      const dateNTime = `${this.getCurrentTime().toLocaleDateString('en-US')}, ${this.getCurrentTime().toLocaleTimeString('en-US')}`;
      const generatedDateTime = [
        {
          style: 'setraTable',
          layout: 'noBorders',
          table: {
            widths: [80, '*'],
            body: [
              ['Generated on: ', dateNTime],
            ],
          },
        },
      ];
      this.doc.content.push(generatedDateTime);

      // Adding user name generated by here
      const generatedUser = [
        {
          style: 'setraTable',
          layout: 'noBorders',
          table: {
            widths: [80, '*'],
            body: [
              ['Generated by: ', this.GeneratedBy],
            ],
          },
        },
      ];
      this.doc.content.push(generatedUser);

      // Adding meter information on top of the logs table
      const installRec = [
        { text: '\nMeter Information', style: 'subheader' },
        {
          style: 'setraTable',
          layout: 'noBorders',
          table: {
            widths: [200, '*'],
            body: [
              ['Manufacturer', 'Setra Systems, Inc.'],
              ['Product', `SPM${this.$store.getDeviceModelNumberText()}EDN`],
              ['Serial Number', this.storeState.data.deviceInfo.serial],
              ['Meter Install Location', this.storeState.data.report.meter.location],
              ['Power Factor Sign Convention', this.powerFactorOptions[this.storeState.data.general.defaults.powerFactorSign].text],
              ['Demand Window', this.storeState.data.general.defaults.demandWindow],
            ],
          },
        },
      ];
      this.doc.content.push(installRec);

      // Adding alarm setup table here
      const alarmList = [
        { text: '\nAlarm Setup', style: 'subheader' },
        {
          style: 'setraTable',
          table: {
            widths: [20, 110, '*', '*', '*', '*', 30, 30],
            headerRows: 1,
            body: [
              [{ text: '#', style: 'tableHeader' }, { text: 'Type', style: 'tableHeader' }, { text: 'Vin/Line/Load/CT', style: 'tableHeader' }, { text: 'Alarm Set Point', style: 'tableHeader' }, { text: 'Deadband', style: 'tableHeader' }, { text: 'Delay Seconds', style: 'tableHeader' }, { text: 'LED', style: 'tableHeader' }, { text: 'Relay', style: 'tableHeader' }],
            ],
          },
        },
      ];
      // loop over alarms
      for (let ai = 0; ai < this.storeState.data.alarms.length; ai++) {
        const alarmObj = this.storeState.alarmTypes.find(({ value }) => value === this.storeState.data.alarms[ai].type);
        const alarmItem = [
          this.storeState.data.alarms[ai].id + 1,
          alarmObj.text,
          this.getVinLineLoadOrCtText(this.storeState.data.alarms[ai]),
          (alarmObj.setPointApplicable ? `${this.storeState.data.alarms[ai].setPoint} ${alarmObj.unit}` : '#NA'),
          (alarmObj.deadbandUnit !== '' ? `${this.storeState.data.alarms[ai].deadband} ${alarmObj.deadbandUnit}` : '#NA'),
          (alarmObj.delayApplicable ? this.storeState.data.alarms[ai].delay : '#NA'),
          (this.storeState.data.alarms[ai].led ? 'Yes' : 'No'),
          (this.storeState.data.alarms[ai].relay ? 'Yes' : 'No'),
        ];
        alarmList.find(({ style }) => style === 'setraTable').table.body.push(alarmItem);
      }
      this.doc.content.push(alarmList);

      // Adding alarm logs table and contents here
      const alarmLogList = [
        { text: '\nAlarm Logs', style: 'subheader' },
        {
          style: 'setraTable',
          table: {
            widths: [65, 75, 150, 60, 60, 30, 30],
            headerRows: 1,
            body: [
              [{ text: 'Date', style: 'tableHeader' }, { text: 'Time', style: 'tableHeader' }, { text: 'Alarm Config', style: 'tableHeader' }, { text: 'Old State', style: 'tableHeader' }, { text: 'New State', style: 'tableHeader' }, { text: 'LED State', style: 'tableHeader' }, { text: 'Relay State', style: 'tableHeader' }],
            ],
          },
        },
      ];
      // loop over alarm log list
      for (let i = this.storeState.alarmLog.length - 1; i >= 0; i--) {
        const logItem = [
          this.realtimeTimestampToDate(this.storeState.alarmLog[i].timeEpoch),
          this.realtimeTimestampToTime(this.storeState.alarmLog[i].timeEpoch),
          this.$store.getAlarmTextForAlarmLogs(this.storeState.alarmLog[i].alarmConfig),
          this.$store.getStateTextForAlarmLogs(this.storeState.alarmLog[i].oldState),
          this.$store.getStateTextForAlarmLogs(this.storeState.alarmLog[i].alarmConfig.state),
          (this.storeState.alarmLog[i].led ? 'Yes' : 'No'),
          (this.storeState.alarmLog[i].relay ? 'Yes' : 'No'),
        ];
        alarmLogList.find(({ style }) => style === 'setraTable').table.body.push(logItem);
      }
      this.doc.content.push(alarmLogList);

      this.$timer.start('downloadAlarmLogs');
    },
    downloadAlarmLogs() {
      const fileName = `SPM${this.$store.getDeviceModelNumberText()}EDN_${this.storeState.data.deviceInfo.serial}_Alarm_Log.pdf`;
      pdfMake.createPdf(this.doc).download(fileName);
      this.updateDialog = false;
      this.updateText = '';
      this.GeneratedBy = '';
      this.$timer.stop('downloadAlarmLogs');
    },

    realtimeTimestampToDate(value) {
      return new Date(value * 1000).toLocaleDateString('en-US');
    },
    realtimeTimestampToTime(value) {
      return new Date(value * 1000).toLocaleTimeString('en-US');
    },
    getCurrentTimeUtc() {
      let dateTime = new Date(this.storeState.now.getTime()); // Get date time (but in browser's timezone)
      dateTime = new Date(dateTime.getTime() + (dateTime.getTimezoneOffset() * 60000)); // get date time in UTC
      return dateTime;
    },
    getCurrentTime() {
      let dateTime = this.getCurrentTimeUtc();
      if (this.storeState.timezoneIndex !== -1 && this.storeState.timezones.length !== 0) { // Change date time to configured timezone
        dateTime = new Date(dateTime.getTime() + (this.storeState.timezones[this.storeState.timezoneIndex].offsetInt * 1000));
      }
      return dateTime;
    },

    close() {
      this.updateDialog = false;
      this.updateText = '';
      this.generatedByDialog = false;
      this.GeneratedBy = '';
    },
    confirm() {
      if (this.GeneratedBy === '') {
        return;
      }
      this.generatedByDialog = false;
      if (this.GeneratedBy !== '') {
        this.exportAlarmLogs();
      }
    },
    cancel() {
      this.generatedByDialog = false;
      this.GeneratedBy = '';
    },
    updateAlarm() {
      this.$store.updateAlarmStates();
      this.$store.updateAlarmLed();
      this.$store.updateAlarmRelay();
    },

    getVinLineLoadOrCtText(item) {
      if (this.storeState.alarmTypes[item.type].vinApplicable) {
        return `Vin ${item.vinLineLoadOrCt + 1}`;
      }
      if (this.storeState.alarmTypes[item.type].lineApplicable) {
        return (item.vinLineLoadOrCt > 2) ? `Vin 2 - Line ${item.vinLineLoadOrCt - 2}` : `Vin 1 - Line ${item.vinLineLoadOrCt + 1}`;
      }
      if (this.storeState.alarmTypes[item.type].loadApplicable) {
        if (this.storeState.data.loads.length === 0) {
          return `Load ${item.vinLineLoadOrCt + 1}`;
        }
        if (item.vinLineLoadOrCt > this.storeState.data.loads.length - 1) {
          return `Load ${item.vinLineLoadOrCt + 1}`;
        }
        return `Load ${item.vinLineLoadOrCt + 1} - ${this.storeState.data.loads[item.vinLineLoadOrCt].name}`;
      }
      if (this.storeState.alarmTypes[item.type].ctApplicable) {
        return `CT ${item.vinLineLoadOrCt + 1}`;
      }
      return '#NA';
    },

    testGetState(alarmIndex) {
      ajax.get(`config/alarm/${alarmIndex}/state`)
        .then((response) => { // eslint-disable-line no-unused-vars
          // console.log(`get alarm ${alarmIndex} state: ${JSON.stringify(response.data)}`);
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          this.$store.addEventLog(`Failed to perform a get alarm state. ${e}`);
        });
    },

    testSetState(alarmIndex, newValue) {
      const newState = { state: newValue };
      ajax.put(`config/alarm/${alarmIndex}/state`, newState)
        .then(() => {
          // console.log(`set alarm ${alarmIndex} to state ${newValue}.`);
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          this.$store.addEventLog(`Failed to perform a get alarm state. ${e}`);
        });
    },

    getBase64Image(img) {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL('image/png');
      return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
    },

    OEMlabel() {
      if (this.storeState.style === 'fluke') {
        return this.getBase64Image(this.$refs.flukeLabel);
      }
      if (this.storeState.style === 'siemens') {
        return this.getBase64Image(this.$refs.siemensLabel);
      }
      return this.getBase64Image(this.$refs.setraLabel);
    },

    getOEMLabelWidth() {
      if (this.storeState.style === 'fluke') {
        return 120;
      }
      if (this.storeState.style === 'siemens') {
        return 169;
      }
      return 80;
    },

    getOEMLabelHeight() {
      if (this.storeState.style === 'fluke') {
        return 36;
      }
      if (this.storeState.style === 'siemens') {
        return 27;
      }
      return 40;
    },
  },
  filters: {
    realtimeTimestampToDate(value) {
      return new Date(value * 1000).toLocaleDateString('en-US');
    },
    realtimeTimestampToTime(value) {
      return new Date(value * 1000).toLocaleTimeString('en-US');
    },
  },

  timers: {
    updateAlarm: { time: 1000, repeat: true, autostart: true },
    downloadAlarmLogs: { time: 1000, repeat: false, autostart: false },
  },
};
</script>

<style>
  .notApplicable.v-input>.v-input__control>.v-input__slot>.v-text-field__slot>input {
    color: #999999 !important;
  }
  .textFieldAsLabel.v-input>.v-input__control>.v-input__slot:before {
      border-style: none !important;
  }
  .textFieldAsLabel.v-input>.v-input__control>.v-input__slot:after {
      border-style: none !important;
  }
  .disabledCheckbox.v-input>.v-input__control>.v-input__slot>.v-input--selection-controls__input {
      color: #666666 !important
  }
</style>
